import {
  faGoogle,
  faHubspot,
  faMicrosoft,
  faShopify,
  faWikipediaW
} from '@fortawesome/free-brands-svg-icons';

const brandsIcons = {
  google: faGoogle,
  hubspot: faHubspot,
  microsoft: faMicrosoft,
  shopify: faShopify,
  'wikipedia-w': faWikipediaW
};

export type BrandIcon = keyof typeof brandsIcons;
export default Object.values(brandsIcons);
